import React, { useState, useEffect ,useRef } from "react";
import {
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  
         CircularProgress,
          Avatar, 
          Box,
  Button,
} from "@mui/material";
import { BarChart, XAxis, YAxis, Bar } from 'recharts';
import { MdGroup } from 'react-icons/md';


import { useNavigate } from 'react-router-dom';
import { BsPersonCheckFill } from 'react-icons/bs';
import { PieChart, Pie, Cell,  Tooltip , ResponsiveContainer} from "recharts";

import { PiStudentBold } from "react-icons/pi";
import { GlobalStyles, width } from "@mui/system";

import { BsPersonPlusFill } from "react-icons/bs";
import { BsLightningFill } from "react-icons/bs";
import { IoIosCash } from 'react-icons/io';
import { BsFillCreditCardFill } from 'react-icons/bs'; 
import { useAuth } from "../../../AuthProvider"; 






const baseUrl=process.env.REACT_APP_API_BASE_URL
const Admission_DashBoard = () => {

  const navigate = useNavigate();
  const {oId,role,userId,board,pId,feature}=useAuth();
  const [notices, setNotices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loadingNotices, setLoadingNotices] = useState(true);
  const [dateRange, setDateRange] = useState("currentAcademicYear");

  // const [selectedClass, setSelectedClass] = useState("Class-I");
  // const [selectedSection, setSelectedSection] = useState("Section-A"); // Default to SECTION-A
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");
  
  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");

const [sscClassSectionMap, setSscClassSectionMap] = useState({});






//   const [announcements, setAnnouncements] = useState([]);
// const [loadingAnnouncements, setLoadingAnnouncements] = useState(true);
const marqueeRef = useRef(null);
const [announcements, setAnnouncements] = useState({
  exams: [],
  notices: [],
  teachers: [],
  parents: []
});


const [classSectionData, setClassSectionData] = useState([]);
const [classOptions, setClassOptions] = useState([]);
const [sectionOptions, setSectionOptions] = useState([]);



const [error, setError] = useState(null);
const [currentIndex, setCurrentIndex] = useState(0);

 
  // Convert number to Roman numerals
const toRoman = (num) => {
  const romanNumerals = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"];
  return romanNumerals[num - 1] || num;
};

const [studentCounts, setStudentCounts] = useState({});
const [tuitionFeeAmounts, setTuitionFeeAmounts] = useState({});
const [busFeeAmounts, setBusFeeAmounts] = useState({});

  
const [selectedPeriod, setSelectedPeriod] = useState("Last Week");





//expenses bar graph states
const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
  // console.log("Selected User:",UserId);



    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
  useEffect(() => {
    if (isPrincipal) {
      fetchUsers();
    }
  }, []); // ✅ Only runs on mount 


// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----

// const fetchClassRegistrationData = async () => {
//   try {
//     const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
//     const data = await response.json();

//     if (response.ok && Array.isArray(data)) {
//       // Group by class and merge section strings into unique values
//       const classSectionMap = {};

//       data.forEach(item => {
//         const className = item.classRegistration;
//         const sectionList = item.sections.split(",").map(s => s.trim());

//         if (!classSectionMap[className]) {
//           classSectionMap[className] = new Set();
//         }

//         sectionList.forEach(section => classSectionMap[className].add(section));
//       });

//       const classes = Object.keys(classSectionMap);
//       setSscClassOptions(classes); // Class dropdown options
//       setSscClassSectionMap(classSectionMap); // Save for section filtering later

//       // No default selection
//       setSscSelectedClass("");
//       setSscSelectedSection("");
//       setSscSectionOptions([]);
//     }
//   } catch (error) {
//     console.error("Error fetching SSC data:", error);
//   }
// };
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach(item => {
        const className = item.classRegistration;
        const sectionList = item.sections.split(",").map(s => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sectionList.forEach(section => classSectionMap[className].add(section));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes); // Populate class dropdown
      setSscClassSectionMap(classSectionMap); // Save mapping

      // ✅ Set default class and sections (first record)
      const defaultClass = classes[0];
      const defaultSections = Array.from(classSectionMap[defaultClass]);
      const defaultSection = defaultSections.includes("Section-A")
        ? "Section-A"
        : defaultSections[0] || "";

      setSscSelectedClass(defaultClass);
      setSscSectionOptions(defaultSections);
      setSscSelectedSection(defaultSection);
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};



// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if (!UserId || !sscSelectedClass || !sscSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/admissionDashBoard/getAllNewStudents/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setOriginalData(data);
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      if (!selectedCourseType) {
        setSelectedCourseType(data[0] || "");
      }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!UserId || !selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/admissionDashBoard/getAllNewStudents/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setOriginalData(data);
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here






// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);

// Fetch Table Data whenever filters change
useEffect(() => {
  if (board === "SSC") {
    if (!sscSelectedClass || !sscSelectedSection) {
      setOriginalData([])
      setFilteredData([]);
      setLoading(false); // ✅ stop loading even if API not called
      return;
    }
    fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
  } else if (board === "INTERMEDIATE") {
    if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
      setOriginalData([])
      setFilteredData([]);
      
      setLoading(false); // ✅ same here
      return;
    }
    fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
  }
}, [UserId,board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);




useEffect(() => {
  const fetchAnnouncements = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/Announcement/getAnnouncement/${oId}/${pId}`);
      if (!response.ok) throw new Error(`HTTP Error! Status: ${response.status}`);

      const data = await response.json();

      const exams = data.examsAnnouncementDto?.map(
        (exam) => `📅 ${exam.examType.replace("_", " ")} Exam on ${exam.examDate} at ${exam.examTime}`
      ) || [];

      const notices = data.noticeAnnouncementsDtos?.map(
        (notice) => `📢 ${notice.title} on ${notice.purposeDate} `
      ) || [];

      const teachers = data.teacherAnnouncementDto?.map(
        (announcement) => `🎓 ${announcement.title} on ${announcement.purposeDate} `
      ) || [];

      const parents = data.parentAnnouncementDto?.map(
        (meeting) => `👨‍👩‍👧 Parent-Teacher Meeting on ${meeting.purposeDate} `
      ) || [];

      // If all categories are empty, show only one ["📢 No announcements available"]
      const hasAnnouncements = exams.length || notices.length || teachers.length || parents.length;
      const defaultMessage = ["📢 No announcements available"];

      setAnnouncements(
        hasAnnouncements
          ? { exams, notices, teachers, parents }
          : { exams: defaultMessage, notices: [], teachers: [], parents: [] }
      );

    } catch (error) {
      console.error("Error fetching announcements:", error);
      setAnnouncements({ exams: ["📢 No announcements available"], notices: [], teachers: [], parents: [] });
    }
  };

  fetchAnnouncements();
}, [baseUrl, oId]);







const [filteredData, setFilteredData] = useState([]); 
const [originalData, setOriginalData] = useState([]);
const [loading, setLoading] = useState(false);

 const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const [selectedMonth, setSelectedMonth] = useState(months[new Date().getMonth()]);
const [expenseData, setExpenseData] = useState([]);

const getLastThreeMonths = (selectedMonth) => {
  const monthOrder = [
    'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
    'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'
  ];
  
  const index = monthOrder.indexOf(selectedMonth.toUpperCase());
  const result = [];

  for (let i = 2; i >= 0; i--) {
    const monthIndex = (index - i + 12) % 12;
    result.push(monthOrder[monthIndex]);
  }

  return result; // Will return in order: [NOVEMBER, DECEMBER, JANUARY] when selectedMonth is JANUARY
};

useEffect(() => {
  const fetchExpensesBarGraphData = async () => {

     // Check if UserId is available, if not, return early
    // const UserId = userId || selectedUsers;
    if (!UserId) return; // ✅ Don't call API if there's no UserId
  
    try {
      // const UserId = userId || selectedUsers;
      const response = await fetch(`${baseUrl}/api/principal/last-three-months-expenses/${UserId}/${oId}?selectedMonth=${selectedMonth}`);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      const months = getLastThreeMonths(selectedMonth);
      const formattedData = months
      .filter(month => data[month] !== undefined)
      .map((month, index) => ({
        name: month,
        value: data[month],
        color: index === 0 ? "#8884d8" : index === 1 ? "#82ca9d" : "#ff7300",
      }));
      setExpenseData(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }

  };
  fetchExpensesBarGraphData();
}, [UserId,selectedMonth]);

const handleMonthChange = (event) => {
  setSelectedMonth(event.target.value);
};





  const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    padding: "5px",
    gap: "15px",
    width: "100%",
  };
  
  const cardStyle = {
    flex: 1,
    padding: "5px",
    borderRadius: "10px",
    boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.2s",
    backgroundColor: "#fff",
    borderLeft: "5px solid",
  };
  const titleStyle = {
    fontWeight: "bold",
    fontSize: "18px",
    marginBottom: "10px",
  };

  const itemStyle = (borderColor) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    borderRadius: "6px",
    marginBottom: "5px",
    cursor: "pointer",
    fontSize: "14px",
    backgroundColor: "#fff", // Keep background white
    border: `2px solid ${borderColor}`, // Border color added
  });
  
  const iconStyle = (bgColor) => ({
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    backgroundColor: bgColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "8px",
    padding: "3px",
  });

  
  
  const pieData = [
    // { name: "Total Tuition Fee", value: tuitionFeeAmounts.tutionFeePayments  || 0, color: "#EC407A" },
    { name: "Tuition Fee Paid", value: tuitionFeeAmounts.tutionFeePaid || 0, color: "#28a745" },
    { name: "Tuition Fee Unpaid", value:tuitionFeeAmounts.tutionFeeUnPaid   || 0, color: "#DC3545" },
    // { name: "Total Bus Fee", value: busFeeAmounts.busFeePayments || 0, color: "#1976D2" },
     ...((feature === "CORE" || feature === "ULTRA")? [
    { name: "Bus Fee Paid", value: busFeeAmounts.busFeePaid  || 0, color: "#669DFF" },
    { name: "Bus Fee Unpaid", value: busFeeAmounts.busFeeUnPaid  || 0, color: "#F166EC" }, // Added a new color for this category
      ]: []), // Don't include 'Packages' if not ULTRA
];

// Check if all values are zero to show fallback data
const hasData = pieData.some((item) => item.value > 0);

// Default placeholder data when no real data is available
const defaultPieData = [{ name: "No Data Available", value: 1, color: "#d3d3d3" }];

// Use actual data if available; otherwise, use fallback data
const finalPieData = hasData ? pieData : defaultPieData;


  const cardData = [
    {
      title: "Students Overview",
      color: "#007bff",
      items: [
        { label: "TOTAL STUDENTS", value: studentCounts.totalStudents || 0, icon: <PiStudentBold />, path: "/AllStudentList", bgColor: "#cce5ff" },
        { label: "NEW STUDENT", value: studentCounts.newStudents || 0, icon: <BsPersonPlusFill />, path: "/NewRegisterdStudents", bgColor: "#cce5ff" },
        { label: "EXISTING STUDENTS", value: studentCounts.existingStudents || 0, icon: <MdGroup />, path: "/ExistingStudentsList", bgColor: "#c8e6c9" },
      ],
    },
    {
      title: "Tuition Fee",
      color: "#28a745",
      items: [
        { label: "Total Fee", value: `₹${tuitionFeeAmounts.tutionFeePayments || 0}`, icon: <IoIosCash />, path: "/FeesDetailsList", bgColor: "#cce5ff" },
        { label: "PAID", value: `₹${tuitionFeeAmounts.tutionFeePaid || 0}`, icon: <BsFillCreditCardFill />, path: `/PaidFeesList?dateRange=${dateRange}`, bgColor: "#d4edda" },
        { label: "UNPAID", value: <span style={{ color: "#DC3545" }}>{`₹${tuitionFeeAmounts.tutionFeeUnPaid || 0}`}</span>, icon: <BsFillCreditCardFill />, path: `/UnPaidFeesList?dateRange=${dateRange}`, bgColor: "#f8d7da" },
      ],
    },

     ...((feature === "CORE" || feature === "ULTRA")? [
    {
      title: "Bus Fee",
      color: "#dc3545",
      items: [
        { label: "Total Fee", value:<span style={{ color: "#28a745" }}>{ `₹${busFeeAmounts.busFeePayments || 0}`}</span>, icon: <IoIosCash />, path: "/BusFeesDetailsList", bgColor: "#cce5ff" },
        { label: "PAID", value:<span style={{ color: "#28a745" }}>{ `₹${busFeeAmounts.busFeePaid || 0}`}</span>, icon: <BsFillCreditCardFill />, path: `/PaidBusFeeList?dateRange=${dateRange}`, bgColor: "#d4edda" },
        { label: "UNPAID", value: `₹${busFeeAmounts.busFeeUnPaid || 0}`, icon: <BsFillCreditCardFill />, path: `/UnpaidBusFeeList?dateRange=${dateRange}`, bgColor: "#f8d7da" },
      ],
    },

  ]: []), // Don't include 'Packages' if not ULTRA

  ];


  
useEffect(() => {
  // Skip API call if both values are missing
  if (!UserId) return;

  const fetchStudentCounts = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/admissionDashBoard/countAllStudents/${oId}/${UserId}`
      );

      if (!response.ok) {
        console.error("Error fetching student data:", response.status);
        return;
      }

      const data = await response.json();
      setStudentCounts(data);
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  fetchStudentCounts();
}, [oId,UserId]);






const fetchNotices = async () => {
    setLoadingNotices(true); // Start loading
    try {
      const response = await fetch(`${baseUrl}/api/noticeBoard/getAll/${oId}/${pId}`); // Replace with your API URL
      const data = await response.json();
      // ✅ Sort notices by purposeDate (future dates first)
      data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));

      setNotices(data); // Assuming the response is an array
    } catch (error) {
      console.error("Error fetching notices:", error);
    }finally {
      setLoadingNotices(false); // Stop loading
    }

  };
useEffect(() => {
  fetchNotices();
}, []);


 // Filter notices based on search query
 const filteredNotices = notices.filter((notice) => {
  return (
    notice.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
    notice.purposeDate.toLowerCase().includes(searchQuery.toLowerCase())
    
  );
});


//TutionFeeAmounts
const fetchTutionFeeAmounts = async () => {
  if (!UserId) return;
  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (dateRange) { // ✅ Changed to 'dateRange'
      case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllTodayTutionPayments/${formattedDate}/tution_fee/${oId}/${UserId}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllYesterDayTutionPayments/${formattedDate}/tution_fee/${oId}/${UserId}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllLastWeekTutionPayments/${formattedDate}/tution_fee/${oId}/${UserId}`;
        break;
      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllThisMonthTutionPayments/${formattedDate}/tution_fee/${oId}/${UserId}`;
        break;
      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllLastSixMonthsTutionPayments/${formattedDate}/tution_fee/${oId}/${UserId}`;
        break;
      case "currentAcademicYear":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllCurrentAcademicYearTutionPayments/${formattedDate}/tution_fee/${oId}/${UserId}`;
        break;
      default:
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllTodayTutionPayments/${formattedDate}/tution_fee/${oId}/${UserId}`;
        break;
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();
    setTuitionFeeAmounts(data);
    
  } catch (error) {
    console.error("Error fetching tuition fee amounts:", error);
  }
};

useEffect(() => {
  fetchTutionFeeAmounts();
}, [UserId,dateRange]); 

//BusFeeAmounts
const fetchBusFeeAmounts = async () => {
  if(!UserId) return;
  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (dateRange) { // ✅ Changed to 'dateRange'
      case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllTodayBusPayments/${formattedDate}/bus_fee/${oId}/${UserId}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllYesterdayBusPayments/${formattedDate}/bus_fee/${oId}/${UserId}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllLastWeekBusPayments/${formattedDate}/bus_fee/${oId}/${UserId}`;
        break;
      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllThisMonthBusPayments/${formattedDate}/bus_fee/${oId}/${UserId}`;
        break;
      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllLastSixMonthsBusPayments/${formattedDate}/bus_fee/${oId}/${UserId}`;
        break;
      case "currentAcademicYear":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllCurrentAcademicYearBusPayments/${formattedDate}/bus_fee/${oId}/${UserId}`;
          break;
      default:
        // endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllTodayBusPayments/${formattedDate}/bus_fee/${oId}/${UserId}`;
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllCurrentAcademicYearBusPayments/${formattedDate}/bus_fee/${oId}/${UserId}`;
        break;
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();
    setBusFeeAmounts(data);
    
  } catch (error) {
    console.error("Error fetching tuition fee amounts:", error);
  }
};

useEffect(() => {
  fetchBusFeeAmounts();
}, [dateRange,UserId]); 

return (
    <div style={{ backgroundColor: "#F5F5F6", minHeight: "100vh", padding: "10px" }}>
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
        `}
      </style>

      {/* Grid for Teachers and Students Stats */}
      <Grid container spacing={0} style={{ marginTop: "5%" }}>
      <div style={containerStyle}>
      {cardData.map((card, index) => (
        <div key={index} style={{ ...cardStyle, borderLeftColor: card.color }}>
         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", ...titleStyle }}>
  <div>{card.title}</div>

  {/* Show dropdown only for "Tuition Fee" card */}
  {/* {card.title === "Tution Fee" && (
    <FormControl variant="outlined" size="small" style={{ width: "150px" }}>
      <InputLabel>Select Date</InputLabel>
      <Select
    labelId="pie-select-label"
    value={dateRange}
    onChange={(e) => setDateRange(e.target.value)}
    label="Date Range"
    style={{ height: "30px", fontSize: "12px" }}
  >
    
    <MenuItem value="today">Today</MenuItem>
    <MenuItem value="yesterday">Yesterday</MenuItem>
    <MenuItem value="lastWeek">Last Week</MenuItem>
    {/* <MenuItem value="lastMonth">Last Month</MenuItem> *
    <MenuItem value="CurrentMonth">CurrentMonth</MenuItem>
    <MenuItem value="last6Months">Last 6 Months</MenuItem>
    <MenuItem value="last365Days">Last365Days</MenuItem>
    <MenuItem value="CurrentFinancialYear">Current FinancialYear</MenuItem>
    <MenuItem value="PreviousFinancialYear">Previous FinancialYear</MenuItem>
  </Select>
    </FormControl>
  )} */}
</div>


          {card.items.map((item, idx) => (
            <div
              key={idx}
              style={itemStyle(item.bgColor)} // Apply border color from bgColor
              onClick={() => navigate(item.path)}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#e8f0fe";
                e.currentTarget.style.transform = "scale(1.02)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#f9f9f9";
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={iconStyle(item.bgColor)}>{item.icon}</div>
                <span style={{ fontWeight: "bold" }}>{item.label}</span>
              </div>
              <span style={{ fontWeight: "bold", color: card.color }}>{item.value}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
</Grid>


<marquee
    ref={marqueeRef} // Attach the ref to the marquee
    behavior="scroll"
    direction="right"
    scrollamount="5"
    onMouseEnter={() => marqueeRef.current && marqueeRef.current.stop()}
    onMouseLeave={() => marqueeRef.current && marqueeRef.current.start()}
    style={{
      marginTop: "13px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "4px 0",
      width: "100%",
      whiteSpace: "nowrap",
    }}
  >
    {[
      ...announcements.exams,
      ...announcements.notices,
      ...announcements.teachers,
      ...announcements.parents,
    ].map((announcement, index) => (
      <span key={index} style={{ marginRight: "20px" }}>
        {announcement}
      </span>
    ))}
  </marquee>

      <div style={{ display: "flex", marginTop: "5px", paddingTop: "5px", justifyContent: "space-between" }}>

         {/* Card containing table title, class selector, and table */}
         <Paper style={{ flex: 2, padding: '5px', backgroundColor: '#FFFFFF', borderRadius: '8px', marginRight: '5px' ,height:"250px"}}>
            <div style={{ flex: 2, marginLeft: '0px', paddingLeft: '10px', paddingRight: '10px', overflow: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <Typography
    variant="h5"
    style={{
      fontWeight: 'bold',
      paddingLeft: '5px',
      marginTop: '5px',
    }}
  >
    New Joining
  </Typography>

  <div style={{ display: 'flex', gap: '10px', marginLeft: 'auto', marginTop: '10px', paddingBottom: '10px' }}> 


  {board === "SSC" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="class-select-label">Select Class</InputLabel>
      <Select
        labelId="class-select-label"
        value={sscSelectedClass}
        // onChange={(e) => setSscSelectedClass(e.target.value)}
         onChange={(e) => {
          const selected = e.target.value;
          setSscSelectedClass(selected);
      
          const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
          setSscSectionOptions(sections);
          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
        }}
        label="Select Class"
        sx={{ height: 35 }}
      >
        {sscClassOptions.map((cls) => (
          <MenuItem key={cls} value={cls}>{cls}</MenuItem>
        ))}
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel id="section-select-label">Select Section</InputLabel>
      <Select
        labelId="section-select-label"
        value={sscSelectedSection}
        onChange={(e) => setSscSelectedSection(e.target.value)}
        label="Select Section"
        sx={{ height: 35 }}
        disabled={sscSectionOptions.length === 0}
      >
        {sscSectionOptions.map((section) => (
          <MenuItem key={section} value={section}>{section}</MenuItem>
        ))}
      </Select>
    </FormControl>
  </>
)}


{board === "INTERMEDIATE" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        value={interSelectedClass}
        onChange={(e) => setInterSelectedClass(e.target.value)}
        label="Select Year"
        sx={{ height: 35 }}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel id="course-type-label">Select Course</InputLabel>
      <Select
        labelId="course-type-label"
        value={selectedCourseType}
        onChange={(e) => setSelectedCourseType(e.target.value)}
        label="Select Course"
        sx={{ height: 35 }}
      >
        {courseOptions.map((course, index) => (
          <MenuItem key={index} value={course}>{course}</MenuItem>
        ))}
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
      <Select
        labelId="intermediate-section-select-label"
        value={interSelectedSection}
        onChange={(e) => setInterSelectedSection(e.target.value)}
        label="Select Section"
        sx={{ height: 35 }}
      >
        {interSectionOptions.map((section, index) => (
          <MenuItem key={index} value={section}>{section}</MenuItem>
        ))}
      </Select>
    </FormControl>
  </>
)}





</div>

</div>
    <GlobalStyles
      styles={{
        '.custom-sidebar-scrollbar': {
          scrollbarWidth: 'thin', // For Firefox
          scrollbarColor: 'grey #e0e0e0',
        },
        '.custom-sidebar-scrollbar::-webkit-scrollbar': {
          width: '6px', // For WebKit-based browsers
        },
        '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
          background: '#f1f1f1', // Track color
        },
        '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
          backgroundColor: 'grey', // Thumb color
          borderRadius: '10px',
        },
        '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555',
        },
      }}
    />
  <TableContainer
  component={Paper}
  sx={{
    borderRadius: 2,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    maxHeight: "185px",
    overflow: "auto",
  }}
  className="custom-sidebar-scrollbar"
>
  <Table stickyHeader>
    <TableHead>
      <TableRow>
        <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4", fontWeight: "Bold" }}>S.No</TableCell>
        <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4", fontWeight: "Bold" }}>Admission Date</TableCell>
        <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4", fontWeight: "Bold" }}>Student Name</TableCell>
        {(board === "INTERMEDIATE" ) && (
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Course
                  </TableCell>
                  )}
        <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4", fontWeight: "Bold" }}>{board === "INTERMEDIATE" ? "Year" : "Class"}</TableCell>
        <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4", fontWeight: "Bold" }}>Section</TableCell>
        <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4", fontWeight: "Bold" }}>Gender</TableCell>
      </TableRow>
    </TableHead>
    {loading ? (
      <TableBody>
        <TableRow>
          <TableCell colSpan={7} style={{ textAlign: "center", padding: "20px" }}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <CircularProgress />
              <Typography variant="body2" sx={{ mt: 1 }}>
                Loading Data...
              </Typography>
            </Box>
          </TableCell>
        </TableRow>
      </TableBody>
    ) : filteredData.length === 0 ? (
      <TableBody>
        <TableRow>
          <TableCell colSpan={7} sx={{ textAlign: "center" }}>
            No data found
          </TableCell>
        </TableRow>
      </TableBody>
    ) : (
      <TableBody>
        {filteredData.map((row, index) => (
          <TableRow
            key={row.admissionNumber}
            style={{
              backgroundColor: "white",
              transition: "background-color 0.3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f5f5f5";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "white";
            }}
          >
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{index + 1}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{row.admissionDate}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{`${row.firstName} ${row.lastName}`}</TableCell>
            {board === "INTERMEDIATE" && (
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.course}
                      </TableCell>
                      )}
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{row.romanNumberClass}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{row.sections}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{row.gender}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    )}
  </Table>
</TableContainer>
  </div>
        </Paper>


        {/* pie chart */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <TableContainer
                  component={Paper}
                  style={{
                    height: "250px",
                    width: "100%",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "8px",
                    paddingTop: "1px",
                    boxShadow: "none",
                    border: "none",
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px 10px",
                    }}
                  >
                    <Typography variant="h6" style={{ fontWeight: "bold", color: "#333" }}>
                      Payments
                    </Typography>

                    {/* Date Range Dropdown */}
                    <FormControl variant="outlined" size="small" style={{ width: "140px" }}>
                      <InputLabel>Select DateRange</InputLabel>
                      <Select
                        value={dateRange}
                        onChange={(e) => setDateRange(e.target.value)}
                        label="Select DateRange"
                        style={{ height: "30px", fontSize: "12px" }}
                      >
                        <MenuItem value="today">Today</MenuItem>
                        <MenuItem value="yesterday">Yesterday</MenuItem>
                        <MenuItem value="lastWeek">Last Week</MenuItem>
                        {/* <MenuItem value="lastMonth">Last Month</MenuItem> */}
                        <MenuItem value="CurrentMonth">Current Month</MenuItem>
                        <MenuItem value="last6Months">Last 6 Months</MenuItem>
                        {/* <MenuItem value="last365Days">Last 365 Days</MenuItem> */}
                        <MenuItem value="currentAcademicYear">Current Academic Year</MenuItem>
                        {/* <MenuItem value="CurrentFinancialYear">Current Financial Year</MenuItem>
                        <MenuItem value="PreviousFinancialYear">Previous Financial Year</MenuItem> */}
                      </Select>
                    </FormControl>
                  </div>

                  {/* Table Content */}
                  <Table style={{ border: "none" }}>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          style={{
                            padding: 0,
                            height: "100%",
                            borderBottom: "none",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "180px", // Fixed height to keep layout stable
                              position: "relative",
                            }}
                          >
                            {/* Pie Chart Section */}
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                              <ResponsiveContainer width={210} height={200}>
                                <PieChart>
                                  <Pie
                                    data={finalPieData}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={25}
                                    outerRadius={55}
                                    paddingAngle={2}
                                    dataKey="value"
                                    label={({ percent }) => (hasData ? `${(percent * 100).toFixed(1)}%` : "")}
                                  >
                                    {finalPieData.map((entry, index) => (
                                      <Cell key={index} fill={entry.color} />
                                    ))}
                                  </Pie>
                                  <Tooltip />
                                </PieChart>
                              </ResponsiveContainer>
                            </div>

                            {/* Labels on Right */}
                            <div
                              style={{
                                paddingLeft: "15px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                              }}
                            >
                              {pieData.map((entry, index) => (
                                <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                                  <div style={{ width: "12px", height: "12px", backgroundColor: entry.color, marginRight: "8px" }} />
                                  <Typography variant="body2" style={{ color: "#333", fontWeight: "bold", fontSize: "11px" }}>
                                    {entry.name}
                                  </Typography>
                                </div>
                              ))}
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>


      </div>

      {/* Notice Board and Expenses */}

                     <div style={{ display: "flex", marginTop: "5px", paddingTop: "5px", justifyContent: "space-between", height: "400px" }}>     
                     

                      {/* //notice board */}
                  <Paper
                    style={{
                      flex: 2,
                      padding: "5px",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "8px",
                      marginRight: "5px",
                      height: "100%",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        flex: 2,
                        marginLeft: "0px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        overflow: "auto",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          position: "sticky",
                          top: "0",
                          backgroundColor: "#FFFFFF",
                          zIndex: 1,
                        }}
                      >
                        <Typography
                          variant="h5"
                          style={{
                            fontWeight: "bold",
                            paddingLeft: "5px",
                            marginTop: "5px",
                            color: "#333",
                          }}
                        >
                          Notice Board
                        </Typography>
                      </div>
                      <GlobalStyles
                        styles={{
                          '.custom-sidebar-scrollbar': {
                            scrollbarWidth: 'thin',
                            scrollbarColor: 'grey #e0e0e0',
                          },
                          '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                            width: '6px',
                          },
                          '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                            background: '#f1f1f1',
                          },
                          '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                            backgroundColor: 'grey',
                            borderRadius: '10px',
                          },
                          '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                            backgroundColor: '#555',
                          },
                        }}
                      />
                      <div className="notice-container custom-sidebar-scrollbar" style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                        {loadingNotices ? (
                          <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
                            <CircularProgress />
                            <Typography variant="body2" sx={{ mt: 1 }}>
                              Loading Notices...
                            </Typography>
                          </Box>
                        ) : filteredNotices.length === 0 ? (
                          <Typography
                            variant="h6"
                            sx={{
                              textAlign: "center",
                              color: "#666",
                              width: "100%",
                              padding: "20px",
                              fontStyle: "italic",
                            }}
                          >
                            No notices available.
                          </Typography>
                        ) : (
                          filteredNotices.map((notice, index) => (
                            <Box
                              key={index}
                              sx={{
                                padding: "15px",
                                borderRadius: "10px",
                                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                                backgroundColor: "#D1E9F6",
                                position: "relative",
                                overflow: "hidden",
                                marginBottom: "10px",
                              }}
                            >
                              {new Date() - new Date(notice.purposeDate) < 24 * 60 * 60 * 1000 && (
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: "0",
                                    right: "0",
                                    backgroundColor: "blue",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "0.75rem",
                                    padding: "6px 12px",
                                    textTransform: "uppercase",
                                    borderTopRightRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                  }}
                                >
                                  New!
                                </Box>
                              )}

                              <Box
                                sx={{
                                  backgroundColor: "#4CAF50",
                                  color: "white",
                                  width:"110px",
                                  padding: "5px 10px",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                  "&:hover": {
                                    transform: "scale(1.05)",
                                  },
                                }}
                              >
                                {notice.purposeDate}
                              </Box>

                              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", marginTop: "10px" }}>
                                {notice.title}
                              </Typography>
                              <Typography variant="body2" sx={{ marginTop: "5px", color: "#333", fontWeight: "bold" }}>
                                {notice.description}
                              </Typography>
                              <Typography variant="body2" sx={{ marginTop: "5px", fontStyle: "italic", color: "#444" }}>
                                Sent By: {notice.nameOfCreatedByNotice}, Time: {notice.time}
                              </Typography>
                            </Box>
                          ))
                        )}
                      </div>
                    </div>
                  </Paper>



              {/* Expenses bar chart */}

              <div style={{ position: "relative", width: "40%" }}>
  <TableContainer
        style={{ backgroundColor: "#FFFFFF", borderRadius: "8px", paddingTop: "20px",height: "100%", }}
      >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 0 10px 10px",
        
      }}
    >
      <Typography variant="h5" style={{ fontWeight: "bold", color: "#333" }}>
        Expenses
      </Typography>

      <div style={{ display: "flex", gap: "10px" }}>
        {/* {isPrincipal && (
          <FormControl fullWidth style={{ width: "150px" }} size="small">
            <InputLabel>Select Admin</InputLabel>
            <Select
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(e.target.value)}
              label="Select Admin"
            >
              {users.map((user) => (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.userId}-{user.firstName} {user.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )} */}
        <FormControl style={{ width: "120px", paddingRight: "10px" }}>
          <InputLabel id="month-select-label" style={{ fontSize: "12px" }}>
            Select Month
          </InputLabel>
          <Select
            labelId="month-select-label"
            value={selectedMonth}
            onChange={handleMonthChange}
            style={{ height: "35px", fontSize: "12px" }}
            label="Select Month"
          >
            {months.map((month, index) => (
              <MenuItem key={index} value={month}>
                {month}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>

    <Table>
      <TableBody>
        <TableRow>
          <TableCell style={{ padding: 0, height: "100%", textAlign: "center", borderBottom: "none" }}>
            {expenseData.length > 0 ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <BarChart width={280} height={300} data={expenseData}>
                  <XAxis dataKey="name" interval={0}/>
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="value">
                    {expenseData.map((entry, index) => (
                      <Cell key={index} fill={entry.color} />
                    ))}
                  </Bar>
                </BarChart>
                <div
                  style={{
                    paddingLeft: "20px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {expenseData.map((entry, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <div
                        style={{
                          width: "10px",
                          height: "10px",
                          backgroundColor: entry.color,
                          marginRight: "5px",
                        }}
                      ></div>
                      <Typography
                        variant="body2"
                        style={{
                          color: "#333",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {entry.name}
                      </Typography>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <Typography variant="body2" style={{ color: "#999", fontSize: "14px" }}>
                No expense data available
              </Typography>
            )}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
</div>



                    </div>
       </div>
  );
};

const cardStyle = {
  padding: "10px",
  position: "relative",
  borderRadius: "8px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
  height: "40px",
};

const headerCellStyle = {
  fontWeight: "bold",
  textAlign: "center",
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "4px",
  fontSize: "12px",
  border: "1px solid #ccc",  // Added border style
};

const cellStyle = {
  textAlign: "center",
  padding: "8px",
  fontSize: "14px",
  color: "#333",
  border: "1px solid #ccc",  
};

const scrollingBarStyle = {
  marginTop: "13px",
  backgroundColor:'#fff',
  borderRadius: "8px",
  padding: "4px 0",
  overflow: "hidden",
  maxWidth: "79vw",
};

const scrollTextStyle = {
  color: "#000000",
  whiteSpace: "nowrap",
  fontWeight: "600",
  cursor: "default",
  display: "inline-block",
  position: "relative",
  animation: "marqueeScrollLTR  linear infinite",
};

export default Admission_DashBoard;